import { render, staticRenderFns } from "./PosExportType.vue?vue&type=template&id=6307b908&scoped=true&"
import script from "./PosExportType.vue?vue&type=script&lang=js&"
export * from "./PosExportType.vue?vue&type=script&lang=js&"
import style0 from "./PosExportType.vue?vue&type=style&index=0&id=6307b908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6307b908",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCombobox,VIcon})
